/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const onboardingPatchInputDataOrganisationHeadcountSchema = z.enum([
	'1-10',
	'11-50',
	'51-200',
	'201-500',
	'501-1000',
	'1000+',
])

export type OnboardingPatchInputDataOrganisationHeadcountSchema = z.infer<
	typeof onboardingPatchInputDataOrganisationHeadcountSchema
>
